// Logout.js
import React from 'react';
import { auth } from '../Firebase'; // Adjust path to your firebase.js file
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const Logout = () => {
  const navigate = useNavigate(); // Initialize navigate function
  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/'); // Redirect to the landing page
      console.log('User logged out');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <button onClick={handleLogout} className="logout-icon-btn">
      <i className="fa fa-sign-out"></i> {/* ✅ Logout Icon */}
    </button>

  );
};

export default Logout;
